import { HttpClient } from '@adapters/HttpClient';
import type { Option, PaymentMethod } from './types';
import globalCache from '@shared/lib/GlobalCache';

export class PaymentMethodsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<Option[]> {
    return globalCache.getOrSet('payment-methods', async () => {
      const raw = await this.httpClient.get<any>('/payment-methods');
      const list = Array.isArray(raw) ? raw : (raw.data ?? []);
      return list.map((m: any) => ({
        id: String(m.id),
        name: m.method,
      }));
    });
  }

  async getPaymentMethods(): Promise<PaymentMethod[]> {
    return globalCache.getOrSet('payment-methods-full', async () => {
      const raw = await this.httpClient.get<any>('/payment-methods');
      const list = Array.isArray(raw) ? raw : (raw.data ?? []);
      return list.map((m: any) => ({
        id: m.id,
        name: m.method,
        code: m.code || m.payment_code || `PAY-${m.id}`,
        description: m.description,
        isActive: m.is_active !== false, // Por defecto true si no viene especificado
      }));
    });
  }
}
